import { useState, useCallback, useEffect } from 'react';
import { apiService } from '../services/api';

interface UseApiState {
  isConnected: boolean;
  isChecking: boolean;
  lastCheck: Date | null;
}

export function useAPI() {
  const [state, setState] = useState<UseApiState>({
    isConnected: false,
    isChecking: true,
    lastCheck: null
  });

  const checkConnection = useCallback(async () => {
    setState(prev => ({ ...prev, isChecking: true }));
    
    try {
      const response = await apiService.healthCheck();
      setState({
        isConnected: response.success,
        isChecking: false,
        lastCheck: new Date()
      });
      return response.success;
    } catch {
      setState({
        isConnected: false,
        isChecking: false,
        lastCheck: new Date()
      });
      return false;
    }
  }, []);

  // Initial check
  useEffect(() => {
    checkConnection();
  }, [checkConnection]);

  // Periodic health check
  useEffect(() => {
    const interval = setInterval(() => {
      checkConnection();
    }, 30000); // Every 30 seconds

    return () => clearInterval(interval);
  }, [checkConnection]);

  return {
    ...state,
    checkConnection,
    api: apiService
  };
}

export default useAPI;
